import { useState } from 'react'
import { useUpdateProject } from '../api/queries'

/**
 * Rettigheder i ampere der, hvor arbejdet foregår (beslutning 109). Tallet står på sagens egen adresse, eller
 * på kunden, når arbejdet foregår hos kunden - så det gælder alle kundens sager på samme adresse.
 */
export function ConnectionAmpsField({
  projectId,
  amps,
  onSite,
  canEdit
}: {
  projectId: number
  amps?: number | null
  onSite?: boolean
  canEdit: boolean
}) {
  const update = useUpdateProject(projectId)
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState(amps ? String(amps) : '')
  const [error, setError] = useState<string | null>(null)

  async function save() {
    setError(null)
    try {
      await update.mutateAsync({ connectionAmps: value ? Number(value) : 0 })
      setEditing(false)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Rettighederne kunne ikke gemmes.')
    }
  }

  return (
    <div>
      <div className="tiny muted">Rettigheder</div>
      {editing ? (
        <div className="row" style={{ gap: 6, flexWrap: 'wrap' }}>
          <input
            type="number"
            min={1}
            max={10000}
            inputMode="numeric"
            style={{ width: 100 }}
            placeholder="f.eks. 63"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <span className="small">A</span>
          <button type="button" className="btn btn--primary btn--sm" disabled={update.isPending} onClick={() => void save()}>
            Gem
          </button>
          <button type="button" className="btn btn--sm" onClick={() => setEditing(false)}>
            Fortryd
          </button>
          {error && <div className="error-box">{error}</div>}
        </div>
      ) : (
        <div className="small">
          {amps ? `${amps} A` : '-'}
          {amps ? <span className="tiny muted"> · {onSite ? 'på sagens adresse' : 'på kundens adresse'}</span> : null}
          {canEdit && (
            <>
              {' '}
              <button
                type="button"
                className="link-button tiny"
                onClick={() => {
                  setValue(amps ? String(amps) : '')
                  setEditing(true)
                }}
              >
                Ret
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}
